import { motion, useScroll, useTransform } from "framer-motion";
import React, { useEffect, useState } from "react";
import { useRef } from "react";
import "./Scrollstack.css";
import rotate4 from "../../assets/img/rotate3.png";

export default function OverlappingGrids() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });

  const grid1Y = useTransform(scrollYProgress, [0, 0], [0, 0]);
  const grid2Y = useTransform(scrollYProgress, [0, 0.4], [150, -300]);
  const grid3Y = useTransform(scrollYProgress, [0, 0.75], [650, -265]);
  const grid4Y = useTransform(scrollYProgress, [0.6, 0.75], [100, 100]);


const [isMobile, setIsMobile] = useState(window.innerWidth < 1300);
  
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1300);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  return (
    <>
        {isMobile ? (
      <div>
        <div className="mobile-fractal">
          <h2 className="mobile-h2-fractal">Industries</h2>
          <p className="mobile-h6-fractal">R&D (Research & Development)</p>
          <p className="mobile-p-fractal">
            Accelerate innovation cycles and optimize research strategies
            with predictive analytics and AI-driven insights. Discover
            hidden patterns in data to develop groundbreaking products and
            solutions faster.
          </p>
          <div className="mobile-fractal-content">
            <div className="mobile-p-fractal">
              <span className="mobile-h6-fractal">Key Benefits:</span>
              <ul>
                <li>AI-powered trend prediction</li>
                <li>Smart data visualization for research insights</li>
                <li>Real-time collaboration & data analysis</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mobile-grid-box-card">
          <span className="mobile-icon">A</span>
          <h2>AI-Powered Trend Prediction</h2>
          <p>
            OrbiNexum leverages advanced machine learning models to analyze
            historical and real-time data, identifying emerging trends
            before they become mainstream. This allows R&D teams to:
          </p>
          <ul>
            <li>
              Detect industry shifts and evolving consumer preferences
              early.
            </li>
            <li>Prioritize research efforts on high-impact innovations.</li>
            <li>
              Reduce time-to-market by aligning product development with
              future demands.
            </li>
          </ul>
          <img src={rotate4} alt="Rotating Image" loading="lazy" className="mobile-rotate-img" />
        </div>

        <div className="mobile-grid-box-card">
          <span className="mobile-icon">S</span>
          <h2>Smart Data Visualization for Research Insights</h2>
          <p>
            Handling vast amounts of research data can be overwhelming, but
            OrbiNexum provides:
          </p>
          <ul>
            <li>
              Interactive dashboards that highlight key findings in real time.
            </li>
            <li>
              Advanced pattern recognition to detect correlations between
              variables.
            </li>
            <li>
              Automated anomaly detection to identify unexpected trends that
              could drive new discoveries.
            </li>
          </ul>
          <img
            src={rotate4}
            alt="Rotating Image"
            loading="lazy"
            className="mobile-rotate-img"
          />
        </div>

        <div className="mobile-grid-box-card">
          <span className="mobile-icon">R</span>
          <h2>Real-Time Collaboration & Data Analysis</h2>
          <p>
            Seamless collaboration is crucial in research, and OrbiNexum
            fosters:
          </p>
          <ul>
            <li>
              Cloud-based data sharing, enabling teams to work on the latest
              insights instantly.
            </li>
            <li>
              Cross-functional data integration, allowing multiple departments
              to draw insights from a unified dataset.
            </li>
          </ul>
          <img
            src={rotate4}
            alt="Rotating Image"
            loading="lazy"
            className="mobile-rotate-img"
          />
        </div>
      </div>        
      ) : (
    <div ref={ref} className="all">
      <div className="scroll-container">
        <div className="sticky-container">
          <div style={{ y: grid1Y }} className="d-flex">
            <motion.div style={{ y: grid4Y }} className="fractal">
              <h2 className="h2-fractal">Industries</h2>
              <p className="h6-fractal">R&D (Research & Development)</p>
              <p className="p-fractal w-50">
                Accelerate innovation cycles and optimize research strategies
                with predictive analytics and AI-driven insights. Discover
                hidden patterns in data to develop groundbreaking products and
                solutions faster.
              </p>
              <div className="fractal-content">
                <div className="p-fractal">
                  <span className="h6-fractal">Key Benefits:</span>
                  <ul>
                    <li>AI-powered trend prediction</li>
                    <li>Smart data visualization for research insights</li>
                    <li>Real-time collaboration & data analysis</li>
                  </ul>
                </div>
              </div>
            </motion.div>
            <motion.div className="grid-box-card ">
              <span className="icon">A</span>
              <h2>AI-Powered Trend Prediction</h2>
              <p>
                OrbiNexum leverages advanced machine learning models to analyze
                historical and real-time data, identifying emerging trends
                before they become mainstream. This allows R&D teams to:
              </p>
              <ul>
                <li>
                  Detect industry shifts and evolving consumer preferences
                  early.
                </li>
                <li>Prioritize research efforts on high-impact innovations.</li>
                <li>
                  Reduce time-to-market by aligning product development with
                  future demands.
                </li>
              </ul>
              <img src={rotate4} alt="Rotating Image" loading="lazy" className="rotate-img" />
            </motion.div>
          </div>
          <motion.div style={{ y: grid2Y }} className="grid-box-card ">
            <span className="icon">S</span>
            <h2>Smart Data Visualization for Research Insights</h2>
            <p>
              Handling vast amounts of research data can be overwhelming, but
              OrbiNexum provides:
            </p>
            <ul>
              <li>
                Interactive dashboards that highlight key findings in real time.
              </li>
              <li>
                Advanced pattern recognition to detect correlations between
                variables.
              </li>
              <li>
                Automated anomaly detection to identify unexpected trends that
                could drive new discoveries.
              </li>
            </ul>
            <img
              src={rotate4} // Replace with the actual image path
              alt="Rotating Image"
              loading="lazy"
              className="rotate-img"
            />
          </motion.div>
          <motion.div style={{ y: grid3Y }} className="grid-box-card">
            <span className="icon">R</span>
            <h2>Real-Time Collaboration & Data Analysis</h2>
            <p>
              Seamless collaboration is crucial in research, and OrbiNexum
              fosters:
            </p>
            <ul>
              <li>
                Cloud-based data sharing, enabling teams to work on the latest
                insights instantly.
              </li>
              <li>
                Cloud-based data sharing, enabling teams to work on the latest
                insights instantly.
              </li>
              <li>
                Cross-functional data integration, allowing multiple departments
                to draw insights from a unified dataset.
              </li>
            </ul>
            <img
              src={rotate4} // Replace with the actual image path
              alt="Rotating Image"
              loading="lazy"
              className="rotate-img"
            />
          </motion.div>
        </div>
      </div>
    </div>
      )}
      </>
  );
}
